import Api from '@/services/Api'

export default {
    leaFacturas(operacion,estado,lider,usuario){
        return Api().get('leaFacturas/'+operacion+'/'+estado+'/'+lider+'/'+usuario)
    },
    leaRelacionado(pais,identificacion,factura,remision,documento) {
	if	(remision == '') {
		remision="-"
	}
        return Api().get('leaRelacionado/'+pais+'/'+identificacion+'/'+documento+'/'+factura+'/'+remision)
    },
    leaFacturasCliente(operacion,fecha_factura,identificacion,estado,lider,usuario){
        return Api().get('leaFacturasCliente/'+operacion+'/'+fecha_factura+'/'+identificacion+'/'+estado+'/'+lider+'/'+usuario)
    },
    leaFacturasDocumento(pais,factura,documento_contable,idUsuario){
	let consulta=''
	let dato=factura
	if	(factura.length > 0) {
		consulta="factura"
	} else {
		consulta="contable"
		dato=documento_contable
	}

        return Api().get('leaFacturasDocumento/'+pais+'/'+dato+'/'+consulta+'/'+idUsuario)
    },
    retireFactura(r_facturas){
        return Api().put('retireFactura',r_facturas)
    },

    grabeAsignacion(estado,liderId,userId,r_facturas){
        return Api().put('grabeAsignacion/'+estado+'/'+liderId+'/'+userId,r_facturas)
    },
    grabeAsignacionAutomatica(liderId,r_proveedores){
        return Api().put('grabeAsignacionAutomatica/'+liderId,r_proveedores)
    },
    grabeContab(id,inicio,razon_estado,estado,r_complemento){
        return Api().put('grabeContab/'+id+'/'+inicio+'/'+razon_estado+'/'+estado,r_complemento)
    },
    grabeManualContab(inicio,razon_estado,estado,r_complemento){
        return Api().put('grabeManualContab/'+inicio+'/'+razon_estado+'/'+estado,r_complemento)
    },
    leaOrdenFactura(pais,identificacion,factura,pedido) {
        return Api().get('leaOrdenFactura/'+pais+'/'+identificacion+'/'+factura+'/'+pedido)
    },
    leaPaises(){
        return Api().get('leaPaises')
    },
    leaProveedores(pais,opcion){
        return Api().get('leaProveedores/'+pais+'/'+opcion)
    },
    leaFacturasProveedor(pais, identificacion, nombre, pagina = 1, limite = 500, busquedaFactura = null){
        let complemento = {
            identificacion: identificacion,
            nombre: nombre,
            pagina: pagina,
            limite: limite,
            busquedaFactura: busquedaFactura
        }
        return Api().put('leaFacturasProveedor/' + pais, complemento)
    },
    grabaFacturasProveedor(facturas){
	let data = {}
	data.facturas = facturas

	return Api().put('grabaFacturasProveedor',data)
    },


	grabaCambioAnalista(pais,listCambiaAnalista,nuevoAnalista,idLider) {
		let data = {}
		data.listCambiaAnalista = listCambiaAnalista
		return Api().put('grabaCambioAnalista/'+pais+'/'+nuevoAnalista+'/'+idLider,listCambiaAnalista)
	},


    leaManualControl(pais,factura,identificacion) {
        return Api().get('leaManualControl/'+pais+'/'+factura+'/'+identificacion)
    },
    leaManualFacturas(pais,usuario){
        return Api().get('leaManualFacturas/'+pais+'/'+usuario)
    },
    leaManualFacturasProveedor(pais,identificacion){
        return Api().get('leaManualFacturasProveedor/'+pais+'/'+identificacion)
    },


	leaHomologaciones(pais,identificacion) {
		return Api().get('leaHomologaciones/'+pais+'/'+identificacion)
	},
	leaProveedoresHomologacion(pais){
		return Api().get('leaProveedoresHomologacion/'+pais)
	},
	grabaHomologacion(listHomologaciones){
		let data = {}
		data.listHomologaciones = listHomologaciones
		return Api().put('grabaHomologacion',data)
	},
}
